import { useMemoState } from "./index205.js";
import { Extrude } from "./index209.js";
import { getBuildingCenter } from "./index210.js";
import { useCursor } from "./index211.js";
import { useDoubleRef } from "./index212.js";
import { getWingPoly } from "./index213.js";
import { GetAllBones, RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType as getRgObjectsOfType$1, useFunction } from "@project-rouge/rg-three";
import { DoubleSide, MathUtils } from "three";
import { memo, useMemo } from "react";
import { Line as Line$1 } from "@react-three/drei";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var disableRaycast = () => {};
const BuildingSelector = memo(({ obj, onSelect, buildingName, topOffset, skipBuildingId }) => {
	const allBuildings = useMemo(() => getRgObjectsOfType$1(obj, RG_TYPE.Building), [obj]);
	const buildings = !skipBuildingId ? allBuildings : allBuildings.filter((b) => b.uuid !== skipBuildingId);
	const [hover, setHover] = useMemoState(void 0, [skipBuildingId]);
	const hoverRef = useDoubleRef(hover);
	const onHover = useFunction((building) => {
		if (hoverRef.current === building) return;
		hoverRef.current = building;
		setHover(building);
	});
	const onHoverOut = useFunction((building) => {
		if (hoverRef.current !== building) return;
		hoverRef.current = void 0;
		setHover(void 0);
	});
	return /* @__PURE__ */ jsx(Fragment, { children: buildings.map((b) => /* @__PURE__ */ jsx(BuildingButton, {
		building: b,
		hover: hover === b,
		onPointerEnter: () => onHover(b),
		onPointerOut: () => onHoverOut(b),
		onClick: () => onSelect(b.uuid),
		buildingName,
		topOffset
	}, b.uuid)) });
});
BuildingSelector.displayName = "BuildingSelector";
var BuildingButton = ({ building, onClick, buildingName, hover, onPointerEnter, onPointerOut, topOffset }) => {
	const bones = useMemo(() => GetAllBones(building.data.anatomy), [building]);
	const center = useMemo(() => getBuildingCenter(building), [building]);
	useCursor(hover);
	return /* @__PURE__ */ jsxs("object3D", {
		onPointerMove: useFunction((e) => {
			e.stopPropagation();
			onPointerEnter();
		}),
		onPointerOut,
		onClick: useFunction((e) => {
			e.stopPropagation();
			onClick();
		}),
		children: [hover && /* @__PURE__ */ jsx("object3D", {
			position: center,
			children: buildingName({ building })
		}), bones.map((bone) => /* @__PURE__ */ jsx(WingBoundary, {
			bone,
			building,
			hover,
			topOffset
		}, bone.id))]
	});
};
var WingBoundary = ({ building, bone, hover, topOffset }) => {
	const { topBoundary, bottomBoundary, top } = useMemo(() => {
		return {
			topBoundary: getWingPoly({
				building,
				bone,
				level: bone.floors - 1
			}),
			bottomBoundary: building.data.levels.find((lvl) => lvl.levelIndex === 0).geaPolygon,
			top: building.data.levels.find((lvl) => lvl.levelIndex === bone.floors).floorWorldBottom
		};
	}, [building, bone]);
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx(Extrude, {
			visible: false,
			rotation: [
				90 * MathUtils.DEG2RAD,
				0,
				0
			],
			points: topBoundary,
			"material-side": DoubleSide,
			"material-transparent": true,
			"material-color": "#EBECED",
			"material-opacity": .3,
			"material-depthTest": false,
			"material-depthWrite": false,
			renderOrder: 10,
			extrude: {
				steps: 1,
				depth: -top - topOffset,
				bevelEnabled: false
			}
		}),
		/* @__PURE__ */ jsx(Line$1, {
			position: [
				0,
				top + topOffset,
				0
			],
			rotation: [
				90 * MathUtils.DEG2RAD,
				0,
				0
			],
			points: topBoundary,
			color: "#3B3B5F",
			transparent: true,
			visible: hover,
			raycast: disableRaycast
		}),
		/* @__PURE__ */ jsx(Line$1, {
			points: bottomBoundary,
			color: "#3B3B5F",
			transparent: true,
			visible: hover,
			lineWidth: 2,
			raycast: disableRaycast
		})
	] });
};
export { BuildingSelector };

//# sourceMappingURL=index214.js.map